import { Card } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import WaiverSubmitProvider from "./WaiverSubmitProvider";

export default function WaiverSubmit() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);
  return (
    <WaiverSubmitProvider>
      <Card
        sx={{
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <Outlet />
      </Card>
    </WaiverSubmitProvider>
  );
}
